<div *ngIf="details" class="details-container" role="region" [attr.aria-label]="'iaa.conservationArchive.folder.detailsRegion' | translate">
  <div class="content-wrapper">
    <div class="details">
      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.folder.folderTitle' | translate }}</div>
          <div class="value">{{ details.folderTitle || '-' }}</div>
        </div>

        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.folder.status' | translate }}</div>
          <div class="value">{{ hasScannedFilesTextKey | translate }}</div>
        </div>
        <div class="item-container"></div>
        <!-- <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.folder.archiveCode' | translate }}</div>
          <div class="value">{{ details.archiveCode || '-' }}</div>
        </div> -->
      </div>
<!-- 
      <div class="section fixed-grid">
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.folder.folderNumber' | translate }}</div>
          <div class="value">{{ details.folderNumber || '-' }}</div>
        </div>
        <div class="item-container">
          <div class="label">{{ 'iaa.conservationArchive.folder.site' | translate }}</div>
          <div class="value">{{ details.siteName || '-' }} <span *ngIf="details.siteType">({{ details.siteType }})</span></div>
        </div>
      </div> -->

      <div class="section-accordion">
        <app-accordion-panel [header]="'iaa.conservationArchive.folder.sites' | translate" [count]="hasSiteData ? 1 : 0" [disabled]="!hasSiteData" [selected]="hasSiteData" [currentLanguage]="currentLanguage">
          <div [ngClass]="{'accordion-row header fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}">
            <div>{{ 'iaa.conservationArchive.folder.relatedType' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.siteNumber' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.siteName' | translate }}</div>
          </div>
          <div [ngClass]="{'accordion-row fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}" *ngIf="hasSiteData">
              <div>{{ details.siteType || '-' }}</div>
              <div *ngIf="!canNavigateToSite">{{ details.siteId ? (details.siteId + (details.siteSubId && details.siteSubId !== 0 ? '/' + details.siteSubId : '')) : '-' }}</div>
              <a *ngIf="canNavigateToSite" class="custom-link" role="button" tabindex="0" (click)="onViewSite(details.siteEntityId)" (keydown.enter)="onViewSite(details.siteEntityId)">
                {{ details.siteId }}{{ details.siteSubId && details.siteSubId !== 0 ? '/' + details.siteSubId : '' }}
              </a>
              <a *ngIf="canNavigateToSite" class="custom-link" role="button" tabindex="0" (click)="onViewSite(details.siteEntityId)" (keydown.enter)="onViewSite(details.siteEntityId)">
                {{ details.siteName || '-' }}
              </a>
              <div *ngIf="!canNavigateToSite">{{ details.siteName || '-' }}</div>
            </div>
        </app-accordion-panel>
      </div>

      <div class="section-accordion">
        <app-accordion-panel [header]="'iaa.conservationArchive.folder.additionalFolders' | translate" [count]="details.additionalFolders.length" [disabled]="details.additionalFolders.length === 0" [selected]="details.additionalFolders.length === 1" [currentLanguage]="currentLanguage">
          <div [ngClass]="{'accordion-row header fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}">
            <div>{{ 'iaa.conservationArchive.folder.folderLongId' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.folderTitle' | translate }}</div>
          </div>
          <div [ngClass]="{'accordion-row fixed-grid-3': true, 'en': (currentLanguage | async) === 'en'}" *ngFor="let folder of details.additionalFolders">
            <div>
              <a class="custom-link" role="button" tabindex="0" [appReturnFocus]="'folders:' + folder.entityId" (click)="onViewFolder(folder.entityId)" (keydown.enter)="onViewFolder(folder.entityId)">
                {{ folder.folderLongId }}
              </a>
            </div>
            <div>{{ folder.folderTitle || '-' }}</div>
          </div>
        </app-accordion-panel>
      </div>

      <div class="section-accordion">
        <app-accordion-panel [header]="'iaa.conservationArchive.folder.documents' | translate" [count]="details.documents.length" [disabled]="details.documents.length === 0" [selected]="details.documents.length === 1" [currentLanguage]="currentLanguage">
          <div [ngClass]="{'accordion-row header fixed-grid-2': true, 'en': (currentLanguage | async) === 'en'}">
            <div>{{ 'iaa.conservationArchive.folder.documentLongId' | translate }}</div>
            <div>{{ 'iaa.conservationArchive.folder.documentTitle' | translate }}</div>
          </div>
          <div [ngClass]="{'accordion-row fixed-grid-2': true, 'en': (currentLanguage | async) === 'en'}" *ngFor="let doc of details.documents">
            <div>
              <a class="custom-link" role="button" tabindex="0" [appReturnFocus]="'documents:' + doc.entityId" (click)="onViewDocument(doc.entityId)" (keydown.enter)="onViewDocument(doc.entityId)">
                {{ doc.documentLongId }}
              </a>
            </div>
            <div>{{ doc.documentTitle || '-' }}</div>
          </div>
        </app-accordion-panel>
      </div>
    </div>
  </div>
</div>
